import { defineMessages } from 'react-intl';

export const standardMessages: {
	closeButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	csmFeatureAiEnabledFormsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // Feature: CSM
	csmFeatureCustomerServiceAgentDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	csmFeatureRovoSupportCompanionDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	csmFeatureUnlimitedAgentsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	opsFeatureAssetsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	opsFeatureAutomationRulesDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // Feature: Ops
	opsFeatureRovoOpsAgentDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	opsFeatureUnlimitedAgentsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	serviceTeamsFeatureAutomationRulesDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	serviceTeamsFeatureKnowledgeBaseDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // Feature: Service Teams
	serviceTeamsFeatureRovoAgentDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	serviceTeamsFeatureUnlimitedAgentsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalAddPaymentDetailsButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingCancelAnytimeLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentEndUser: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentEndUserNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentEndUserPaymentEntered: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentEndUserPaymentEnteredNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentPaymentEntered: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingContentPaymentEnteredNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingPlansLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalBillingSeePlansLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreAiEnabledFormsButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreAssetsButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreAutomationsButton: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // CTA — CSM
	standardBenefitsModalExploreCustomerServiceAgentButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreKnowledgeBaseButton: {
		defaultMessage: string;
		description: string;
		id: string;
	}; // CTA — Ops
	standardBenefitsModalExploreRovoOpsAgentButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreRovoServiceAgentButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalExploreRovoSupportCompanionButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalInviteMoreAgentsButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	standardBenefitsModalTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	closeButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.close',
		defaultMessage: 'Close',
		description: 'Aria-label for the close button in the edition benefits modal',
	},
	standardBenefitsModalTitle: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.title',
		defaultMessage: 'Explore your trial',
		description: 'Title for the standard benefits modal',
	},
	standardBenefitsModalBillingContent: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content',
		defaultMessage: 'Add your payment details by {date} to continue using {edition}. {plansLink}',
		description:
			'Billing content for the standard benefits modal. {plansLink} is the “See all plans” link to pricing.',
	},
	standardBenefitsModalBillingContentNoDate: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date',
		defaultMessage:
			'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
		description:
			'Billing content when billing date is unavailable. {edition} is the plan name; {plansLink} is the plans link.',
	},
	standardBenefitsModalBillingPlansLink: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link',
		defaultMessage: 'See all plans.',
		description: 'Link label for the billing line “See all plans” in the standard benefits modal',
	},
	standardBenefitsModalBillingContentPaymentEntered: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered',
		defaultMessage:
			'You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}',
		description:
			'Billing line when payment details are on file. {billingDate} is the next billing date; {plansLink} and {cancelLink} are inline links.',
	},
	standardBenefitsModalBillingContentPaymentEnteredNoDate: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date',
		defaultMessage:
			'You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}',
		description:
			'Billing line when payment is on file but billing date is unavailable. {plansLink} and {cancelLink} are inline links.',
	},
	standardBenefitsModalBillingSeePlansLink: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link',
		defaultMessage: 'See plans',
		description: 'Link label “See plans” in the payment-entered billing line',
	},
	standardBenefitsModalBillingCancelAnytimeLink: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link',
		defaultMessage: 'cancel anytime.',
		description: 'Link label “cancel anytime.” in the payment-entered billing line',
	},
	standardBenefitsModalBillingContentEndUserPaymentEntered: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered',
		defaultMessage: 'Your {edition} trial ends on {billingDate}.',
		description:
			'Billing line for end users (non-billing admins) with payment on file and a known billing date.',
	},
	standardBenefitsModalBillingContentEndUserPaymentEnteredNoDate: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date',
		defaultMessage: 'Your {edition} trial is ending soon.',
		description:
			'Billing line for end users (non-billing admins) with payment on file when billing date is unavailable.',
	},
	standardBenefitsModalBillingContentEndUser: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user',
		defaultMessage:
			'To continue using {edition}, contact your billing admin to add payment details before your trial ends on {billingDate}.',
		description:
			'Billing line for end users (non-billing admins) without payment details and a known billing date.',
	},
	standardBenefitsModalBillingContentEndUserNoDate: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date',
		defaultMessage:
			'To continue using {edition}, contact your billing admin to add payment details before your trial ends.',
		description:
			'Billing line for end users (non-billing admins) without payment details when billing date is unavailable.',
	},
	standardBenefitsModalAddPaymentDetailsButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details',
		defaultMessage: 'Add payment details',
		description: 'Text for the add payment details button in the standard benefits modal',
	},
	standardBenefitsModalExploreRovoServiceAgentButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent',
		defaultMessage: 'Explore Rovo Service agent',
		description: 'Text for the explore Rovo Service agent button in the standard benefits modal',
	},
	standardBenefitsModalExploreKnowledgeBaseButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base',
		defaultMessage: 'Explore Knowledge base',
		description: 'Text for the explore Knowledge base primary button when that feature is selected',
	},
	standardBenefitsModalExploreAutomationsButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations',
		defaultMessage: 'Explore Automations',
		description: 'Text for the explore Automations primary button when that feature is selected',
	},
	standardBenefitsModalInviteMoreAgentsButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents',
		defaultMessage: 'Invite more agents',
		description: 'Text for the invite more agents primary button when unlimited agents is selected',
	},
	// CTA — CSM
	standardBenefitsModalExploreCustomerServiceAgentButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent',
		defaultMessage: 'Explore Customer service agent',
		description: 'Primary CTA when Customer service agent feature is selected (CSM)',
	},
	standardBenefitsModalExploreRovoSupportCompanionButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion',
		defaultMessage: 'Explore Rovo Support Companion',
		description: 'Primary CTA when Rovo Support Companion feature is selected (CSM)',
	},
	standardBenefitsModalExploreAiEnabledFormsButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms',
		defaultMessage: 'Explore AI enabled Forms',
		description: 'Primary CTA when AI enabled Forms feature is selected (CSM)',
	},
	// CTA — Ops
	standardBenefitsModalExploreRovoOpsAgentButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent',
		defaultMessage: 'Explore Rovo Ops agent',
		description: 'Primary CTA when Rovo Ops agent feature is selected (Ops)',
	},
	standardBenefitsModalExploreAssetsButton: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets',
		defaultMessage: 'Explore Assets',
		description: 'Primary CTA when Assets feature is selected (Ops)',
	},
	// Feature: Service Teams
	serviceTeamsFeatureRovoAgentDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description',
		defaultMessage: 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
		description: 'Description for the Rovo Service Agents feature',
	},
	serviceTeamsFeatureKnowledgeBaseDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description',
		defaultMessage:
			'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
		description: 'Description for the Knowledge Base feature',
	},
	serviceTeamsFeatureAutomationRulesDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description',
		defaultMessage: 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
		description: 'Description for the Automation Rules feature',
	},
	serviceTeamsFeatureUnlimitedAgentsDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description',
		defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
		description: 'Description for the Unlimited Agents feature',
	},
	// Feature: CSM
	csmFeatureCustomerServiceAgentDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description',
		defaultMessage:
			'Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload',
		description: 'Description for the Customer service agent feature (CSM)',
	},
	csmFeatureRovoSupportCompanionDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description',
		defaultMessage:
			'Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses',
		description: 'Description for the Rovo Support Companion feature (CSM)',
	},
	csmFeatureAiEnabledFormsDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description',
		defaultMessage:
			'Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed',
		description: 'Description for the handoff feature (CSM)',
	},
	csmFeatureUnlimitedAgentsDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description',
		defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
		description: 'Description for the Unlimited agents feature (CSM)',
	},
	// Feature: Ops
	opsFeatureRovoOpsAgentDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description',
		defaultMessage:
			'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
		description: 'Description for the Rovo Ops agent feature (Ops)',
	},
	opsFeatureAssetsDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description',
		defaultMessage:
			'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
		description: 'Description for the Assets feature (Ops)',
	},
	opsFeatureAutomationRulesDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description',
		defaultMessage: 'Move forward faster with <strong>10x Automation rule runs</strong>',
		description: 'Description for the Automation rule runs feature (Ops)',
	},
	opsFeatureUnlimitedAgentsDescription: {
		id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description',
		defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
		description: 'Description for the Unlimited agents feature (Ops)',
	},
});
